<template src='./chart.pug' lang="pug"></template>

<script>
import ConciliationSituationSummaryFilter from '../chartFilter/ConciliationSituationSummary'
import FinancialSummaryFilter from '../chartFilter/FinancialSummary'
import AllotmentDistributionFilter from '../chartFilter/AllotmentDistributionConciliation'
import DailyBankStatmentFilter from '../chartFilter/DailyBankStatment'
import DigitalWalletBalanceFilter from '../chartFilter/DigitalWalletBalance'
import TaskGadget from '../gadget/TaskGadget'
import openMenu from '../../../events/openMenu'

export default {
  name: 'Chart',

  components: {
    ConciliationSituationSummaryFilter,
    FinancialSummaryFilter,
    AllotmentDistributionFilter,
    DailyBankStatmentFilter,
    DigitalWalletBalanceFilter,
    TaskGadget
  },

  props: {
    id: {
      type: Number
    },
    chart: {
      type: Object
    },
    filters: {
      type: Array
    },
    classTitChart: {
      type: String
    },
    classFilterChart: {
      type: String
    },
    showTaskGadget: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      showChart: !this.chart.isCollapsed
    }
  },

  methods: {
    resize () {
      this.$emit('onResize', this.chart)
    },

    getClassChartTitle (chart) {
      return this._getClass('classTitChart', chart)
    },

    getClassChartFilter (chart) {
      return this._getClass('classFilterChart', chart)
    },

    _getClass (baseClass, chart) {
      if (!chart.container) {
        return baseClass
      }

      const el = Array.from(document.querySelectorAll('div')).find(el => el.getAttribute('id') === chart.idChart.toString())
      if (!el) {
        return baseClass
      }

      if (el.children[0].classList.contains('dragFull')) {
        return baseClass + ' chartFull'
      }

      return baseClass + ' chartMiddle'
    },

    collapseContent () {
      this.showChart = !this.showChart
      this.chart.isCollapsed = !this.chart.isCollapsed
    },

    /**
     * Essa função tem o objetivo de atualizar o tamanho dos componentes do dashboard no momento no qual o usuário abre ou fecha o menu lateral.
     * Porém, essa função só deve ser chamada até o menu lateral fechar (ou abrir) completamente, caso o contrário o tamanho do compoenente será atualizado errado, por exemplo:
     * Imagine que o usuário está com o componente aberto o tamanho do gadget do dashboard possui 400px de lagura,
     * assim que o usuário aciona o botão de fechar o menu até o momento no qual é acionado esse trecho de código é executado passa 100ms.
     * Como o componente de fechar e abrir o menu lateral possui uma animação de 150ms (para se tornar mais "natural") a diferença são 50ms entre os dois ou seja,
     * assim que os charts forem atualizados, eles serão atualizados com base na largura do elemento pai, que ao momento de 100ms passados é de 400px - X + Y, onde:
     * - 400px é a largura original;
     * - X é a diferença da largura original (com o dashboard aberto) para a largura objetivo (com o dashboard fechado);
     * - Y é a largura no qual o chart foi alterado no intervalo de 100ms.
     * Se o objetivo for 300px de largura, então, o chart deve diminuir 100px (400px - 300px) em 150ms.
     * Como no exemplo, em um intervalo de 100ms, o chart diminuiu 66,66px, aplicando na fórmula acima (400px - 100px + 66,66px), o resultado é de 366,66px,
     * ou seja existe uma diferença de 33,34px, essa diferença faz com que o chart fique maior que o elemento pai.
     *
     * O objetivo do timeout é "esperar" o dashboard abrir (ou fechar), escondendo os charts para não causar confusão do usuário, já que, o chart é mostrado do tamanho
     * 400px e somente depois é atualizado, ou seja, o chart mostra a largura maior (ou menor) por um breve intervalo de tempo.
     *
     * ---
     *
     * Q - "Por que não usar CSS da mesma forma que é usada no menu lateral para atualizar o chart?"
     *
     * A - Pelo fato de que a largura do componente é controlada pelas bibliotecas [Highcharts](https://api.highcharts.com) e [vue-highcharts](https://github.com/weizhenye/vue-highcharts),
     * no qual, os dois que irão decidir o tamanho objetivo dos elementos para pode ajustar de acordo com o conteúdo.
     *
     * ---
     *
     * Q - "Porque está usando `window.dispatchEvent(new Event('resize'))`?"
     *
     * A - [A biblioteca "Highcharts" fica escutando esse evento para efetuar o resize, dessa forma irá acionar diretamente o componenete responsável em atualizar quando for o momento correto](https://stackoverflow.com/questions/39486183/onclick-trigger-resize-highcharts/39488060#39488060).
     */
    updateCredits () {
      this.showChart = false
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'))
        this.showChart = true
      }, 150)
    }
  },

  mounted () {
    openMenu.$on('menuOpened', () => {
      this.updateCredits()
    })
  }
}
</script>

<style lang="scss">
.dashboard-top {
  background-color: #EEE;
  height: 400px;
}

.button-content {
  background-color: transparent;
  border: none;
  cursor: pointer;
  height: 36px;
  pointer-events: all;
  width: 36px;

  > i {
    transition: 150ms;

    &.open, &.chartMiddle {
      margin-top: 5px;
      transform: rotate(180deg);
    }
  }
}

/*Estilo para a div dos gráficos*/
.dashboard-chart {
  margin-bottom: 20px;
}

.dashboard-top {
  display: flex;
  background-color: #1a3b5f;
  font-family: 'Inter', sans-serif;
font-weight: 700;
  font-size: 13px;
  color: #FFF;
  height: 36px;
  cursor: move;
  padding-left: 0px;
}

.dashboard-top-chart-name {
  background-color: #40b9bb;
  font-size: 15px;
  padding: 7px 8px;
  float: left;
  height: 36px;
  width: 30%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dashboard-action-bar {
  color: #ffffff;
  width: 100%;
  padding: 0px 15px;
  float: left;
  height: 36px;
  background-color: #1a3b5f;
}

.chart-content {
  width: 100%;

  > .button-content {
    position: absolute;
    right: 15px;

    &.top {
      top: 0;
    }

    &.bottom {
      bottom: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Chart.vue?c2221006